module.exports = __webpack_public_path__ + "img/brave.715efc13.svg";